"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _operators = _interopRequireDefault(require("../operators.js"));
var _CccisdSelect = _interopRequireDefault(require("../../CccisdSelect"));
var _formik = require("formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Operator = function Operator(props) {
  var dataConnector = props.dataConnector,
    name = props.name;
  if (!dataConnector) {
    return null;
  }
  var options = [{
    value: '0',
    label: '- choose operator -'
  }].concat(_toConsumableArray(_operators["default"][dataConnector.type].map(function (operator) {
    return {
      value: operator.code,
      label: operator.title
    };
  })));
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    component: _CccisdSelect["default"],
    options: options,
    showErrorImmediately: true
  });
};
Operator.propTypes = {
  dataConnector: _propTypes["default"].object,
  name: _propTypes["default"].string
};
var _default = exports["default"] = Operator;